"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INLINE_MESSAGE_TYPE_DESC = exports.INLINE_MESSAGE_TYPE_INFO = exports.INLINE_MESSAGE_TYPE_ERROR = exports.INLINE_MESSAGE_TYPE_WARNING = void 0;

var _constants = require("../../skybase-core/notifications/constants");

/**
 * @namespace skybase-components.sb-inline-messages.constants
 */

/**
 * @typedef {String} skybase-components.sb-inline-messages.constants#type
 *
 * @description
 * we have three types of alert so far:
 * <ol>
 *  <li>INLINE_MESSAGE_TYPE_WARNING</li>
 *  <li>INLINE_MESSAGE_TYPE_ERROR</li>
 *  <li>INLINE_MESSAGE_TYPE_INFO</li>
 *  <li>INLINE_MESSAGE_TYPE_DESC</li>
 * </ol>
 *
 */
var INLINE_MESSAGE_TYPE_WARNING = _constants.ALERT_TYPE_WARNING;
exports.INLINE_MESSAGE_TYPE_WARNING = INLINE_MESSAGE_TYPE_WARNING;
var INLINE_MESSAGE_TYPE_ERROR = _constants.ALERT_TYPE_ERROR;
exports.INLINE_MESSAGE_TYPE_ERROR = INLINE_MESSAGE_TYPE_ERROR;
var INLINE_MESSAGE_TYPE_INFO = _constants.ALERT_TYPE_INFO;
exports.INLINE_MESSAGE_TYPE_INFO = INLINE_MESSAGE_TYPE_INFO;
var INLINE_MESSAGE_TYPE_DESC = _constants.ALERT_TYPE_DEFAULT;
exports.INLINE_MESSAGE_TYPE_DESC = INLINE_MESSAGE_TYPE_DESC;
//# sourceMappingURL=constants.js.map